if (!customElements.get('beauty-routine-builder')) {
  customElements.define('beauty-routine-builder', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-routine-form]');
      if (!this.form || this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-routine-config]').textContent);
      this.variant = this.config.variant;
      this.mainToggle = this.querySelector('[data-main-toggle]');
      this.submit = this.querySelector('[data-routine-submit]');
      this.status = this.querySelector('[data-routine-status]');
      this.error = this.querySelector('[data-routine-error]');
      this.errorText = this.querySelector('[data-routine-error-text]');
      this.formatter = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency });
      this.form.hidden = false;
      this.onChange = (event) => {
        const row = event.target.closest('[data-routine-option]');
        if (row && event.target.matches('[data-extra-variant]')) {
          const option = event.target.selectedOptions[0];
          row.dataset.variantId = option.value;
          row.dataset.price = option.dataset.price || '0';
          const toggle = row.querySelector('[data-extra-toggle]');
          toggle.disabled = !option.value || option.disabled;
          if (toggle.disabled) toggle.checked = false;
          row.querySelector('[data-option-price]').textContent = option.value ? this.money(Number(option.dataset.price)) : this.config.chooseOption;
          if (option.dataset.image) {
            const image = row.querySelector('img');
            image.removeAttribute('srcset');
            image.src = option.dataset.image;
          }
        }
        this.update();
      };
      this.onMainInput = (event) => {
        if (event.target.matches('product-info .quantity__input')) this.update();
      };
      this.onSubmit = this.addSelection.bind(this);
      this.onReview = this.reviewBag.bind(this);
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
      document.addEventListener('change', this.onMainInput);
      document.addEventListener('input', this.onMainInput);
      this.querySelector('[data-review-bag]').addEventListener('click', this.onReview);
      if (typeof subscribe === 'function') {
        this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.syncCart());
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const main = this.mainInfo;
          if (main && data.sectionId === main.dataset.section) {
            this.variant = data.variant || { available: false };
            this.update();
          }
        });
      }
      const mainButton = this.mainInfo?.querySelector('.product-form__submit');
      if (mainButton) {
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      }
      document.querySelectorAll('[data-routine-link]').forEach((link) => {
        link.href = '#' + this.id;
        link.hidden = false;
      });
      this.visibilityObserver = new IntersectionObserver(([entry]) => this.classList.toggle('is-in-view', entry.isIntersecting));
      this.visibilityObserver.observe(this);
      this.update();
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.unsubscribeCart?.();
      this.cartSyncToken = (this.cartSyncToken || 0) + 1;
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      document.removeEventListener('change', this.onMainInput);
      document.removeEventListener('input', this.onMainInput);
      this.form?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.querySelector('[data-review-bag]')?.removeEventListener('click', this.onReview);
      this.initialized = false;
    }
    get mainInfo() { return document.querySelector('product-info[data-update-url="true"]') || document.querySelector('product-info'); }
    money(cents) { return this.formatter.format(cents / 100); }
    selection() {
      const items = [];
      const main = this.mainInfo;
      const input = main?.querySelector('product-form input[name="id"]');
      const quantity = Math.max(1, Number(main?.querySelector('.quantity__input')?.value) || 1);
      const button = main?.querySelector('.product-form__submit');
      const nativeForm = input?.closest('form');
      const quantityInput = main?.querySelector('.quantity__input');
      const validQuantity = Number.isInteger(quantity) && (!quantityInput || (quantityInput.value !== '' && Number(quantityInput.value) >= 1 && quantityInput.checkValidity()));
      const validForm = !this.mainToggle.checked || !nativeForm || nativeForm.checkValidity();
      const mainReady = !!input?.value && !this.config.mainRestricted && validQuantity && validForm && !nativeForm?.querySelector('input[type="file"]') && this.variant?.available !== false && !button?.disabled && button?.getAttribute('aria-disabled') !== 'true';
      if (this.mainToggle.checked && mainReady) {
        const item = { id: input.value, quantity, price: Number(this.variant.price) || 0 };
        const formData = new FormData(nativeForm);
        const properties = {};
        formData.forEach((value, name) => {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string' && value) properties[match[1]] = value;
        });
        if (Object.keys(properties).length) item.properties = properties;
        if (formData.get('selling_plan')) item.selling_plan = formData.get('selling_plan');
        items.push(item);
      }
      this.querySelectorAll('[data-routine-option]').forEach((row) => {
        const toggle = row.querySelector('[data-extra-toggle]');
        if (toggle?.checked && !toggle.disabled && row.dataset.variantId) items.push({ id: row.dataset.variantId, quantity: 1, price: Number(row.dataset.price) });
      });
      return { items, quantity, mainReady };
    }
    update() {
      const { items, quantity, mainReady } = this.selection();
      const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
      this.querySelector('[data-selected-total]').textContent = this.money(total);
      this.querySelector('[data-main-price]').textContent = this.money((Number(this.variant?.price) || 0) * quantity);
      this.querySelector('[data-main-quantity]').textContent = quantity;
      this.querySelector('[data-main-variant]').textContent = this.variant?.title === 'Default Title' ? '' : this.variant?.title || '';
      this.submit.disabled = !!this.busy || !items.length || (this.mainToggle.checked && !mainReady);
      this.submit.setAttribute('aria-busy', String(!!this.busy));
      this.submit.textContent = this.busy ? this.config.adding : this.config.addSelected;
      const count = items.reduce((sum, item) => sum + item.quantity, 0);
      this.querySelector('[data-selected-count]').textContent = this.config.count.replace('__COUNT__', String(count));
      this.querySelector('[data-main-unavailable]').hidden = mainReady;
      this.querySelectorAll('[data-routine-option]').forEach((row) => row.classList.toggle('is-selected', !!row.querySelector('[data-extra-toggle]')?.checked));
    }
    clearSelection() {
      this.mainToggle.checked = false;
      this.querySelectorAll('[data-extra-toggle]').forEach((toggle) => { toggle.checked = false; });
    }
    async syncCart() {
      const token = this.cartSyncToken = (this.cartSyncToken || 0) + 1;
      try {
        const response = await fetch(this.config.cartUrl + '.js');
        if (!response.ok) return;
        const cart = await response.json();
        if (!this.isConnected || token !== this.cartSyncToken) return;
        if (cart.items.some((item) => String(item.product_id) === String(this.config.productId))) this.mainToggle.checked = false;
        this.querySelectorAll('[data-routine-option]').forEach((row) => {
          const inBag = cart.items.some((item) => String(item.product_id) === row.dataset.productId);
          const toggle = row.querySelector('[data-extra-toggle]');
          const select = row.querySelector('[data-extra-variant]');
          row.classList.toggle('is-in-bag', inBag);
          if (select) select.disabled = inBag;
          if (toggle) {
            toggle.disabled = inBag || !!(select && !select.value);
            if (inBag) toggle.checked = false;
            row.querySelector('.beauty-routine-option__include').textContent = inBag ? this.config.inBag : this.config.includeExtra;
          }
        });
        this.update();
      } catch {}
    }
    async addSelection(event) {
      event.preventDefault();
      if (this.busy) return;
      const { items, mainReady } = this.selection();
      if (!items.length || (this.mainToggle.checked && !mainReady)) return;
      this.busy = true;
      this.error.hidden = true;
      this.status.textContent = '';
      this.querySelector('fieldset').disabled = true;
      this.update();
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender().map((section) => section.id) || [];
      drawer?.setActiveElement(this.querySelector('h2'));
      if (typeof CartItems !== 'undefined') CartItems.renderVersion += 1;
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items.map(({ price, ...item }) => item), sections, sections_url: window.location.pathname }),
        });
        const data = await response.json();
        if (!response.ok || data.status) throw Object.assign(new Error(), { customerMessage: typeof data.description === 'string' ? data.description : '' });
        if (typeof publish === 'function') await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'beauty-routine-builder', cartData: data });
        this.clearSelection();
        this.status.textContent = this.config.success;
        if (drawer && sections.every((id) => typeof data.sections?.[id] === 'string')) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ ...data, id: data.items?.[0]?.id });
        } else {
          window.location.assign(this.config.cartUrl);
        }
      } catch (error) {
        this.clearSelection();
        this.errorText.textContent = (error.customerMessage ? error.customerMessage + ' ' : '') + this.config.error;
        this.error.hidden = false;
      } finally {
        this.busy = false;
        this.querySelector('fieldset').disabled = false;
        this.update();
      }
    }
    async reviewBag() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) { window.location.assign(this.config.cartUrl); return; }
      try {
        const sections = drawer.getSectionsToRender().map((section) => section.id);
        const response = await fetch(this.config.cartUrl + '?sections=' + sections.join(','));
        const data = await response.json();
        if (!response.ok || !sections.every((id) => typeof data[id] === 'string')) throw new Error();
        const renderedDrawer = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('cart-drawer');
        if (renderedDrawer) drawer.classList.toggle('is-empty', renderedDrawer.classList.contains('is-empty'));
        await this.syncCart();
        drawer.setActiveElement(this.querySelector('[data-review-bag]'));
        drawer.renderContents({ sections: data });
      } catch { window.location.assign(this.config.cartUrl); }
    }
  });
}
